import { classNamesFunction, IStyle } from '@fluentui/react';

export interface IConsentFlowStyle {
  inlineAlertingClass: IStyle;
  footnoteClass: IStyle;
  alertingButtonClass: IStyle;
  buttonClass: IStyle;
}

export const styles: IConsentFlowStyle = {
  inlineAlertingClass: {
    fontFamily: 'Segoe UI',
    fontWeight: '600',
    color: '#A80000',
    marginTop: '20px',
    marginBottom: '10px',
  },
  footnoteClass: {
    marginTop: '20px',
    marginBottom: '10px',
  },
  alertingButtonClass: {
    borderColor: '#A80000',
    color: '#A80000',
    marginRight: '1em',
    marginBottom: '30px',
    selectors: {
      ':disabled': {
        borderColor: 'rgb(243, 242, 241)',
        color: 'rgb(161, 159, 157)',
      },
    },
  },
  buttonClass: {
    marginRight: '1em',
    marginBottom: '30px',
  },
};

const getClassNames = classNamesFunction<{}, IConsentFlowStyle>();
export const classNames = getClassNames(styles);
